export const LOGIN_PATH = '/login';

export const FORGOT_PATH = '/forgot';

export const RESET_PASSWORD_PATH = '/password_recovery';
